import EventClient from "@2u-landing-pages/utils/event-client";
import cloneDeep from "lodash/cloneDeep";
import airtrainJson from "./airtrainForm.json";

async function getPackageJSON(packageUrl: string) {
  const response = await fetch(packageUrl);

  if (!response.ok) {
    throw new Error(`Failed to fetch package: ${response.status}`);
  }

  return response.json();
}

export function formatLeadFormType(leadFormType?: string, location?: string) {
  return `${leadFormType === "TY" ? "TYP" : "LP"}${location ? ` - ${location}` : ""}`;
}

export function prepareFormPackage(formPackage: any, thankYouURL?: string) {
  const pkg = cloneDeep(formPackage);

  if (thankYouURL && pkg.thankYouPageURLs) {
    delete pkg.thankYouPageURLs;
  }

  return pkg;
}

export async function getPackageData(packageId: string, applyDomain: string, leadFormType: string) {
  if (leadFormType === "LP") {
    return getPackageJSON(`https://prospect-form-packages.2u.com/all/${packageId}.json`);
  }

  if (leadFormType === "TY") {
    const finalPackageData = cloneDeep(airtrainJson);
    finalPackageData.applyDomain = applyDomain;
    return finalPackageData;
  }

  return {};
}

export function handleSubmissionFailed(event: any, leadFormType?: string, location?: string) {
  const { multiFormIdentifier, failureReason } = event.details;
  const errorMessage = "Form submission failed: " + failureReason.message;
  const formType = formatLeadFormType(leadFormType, location);

  EventClient.formErrored({
    errorMessage,
    formContext: {
      formType,
      formId: multiFormIdentifier,
    },
  });

  if (typeof window !== "undefined" && window.newrelic?.noticeError) {
    window.newrelic.noticeError(new Error(errorMessage), {
      formType,
      formId: multiFormIdentifier,
      failureReason: errorMessage,
    });
  }
}

export function validateLeadFormProps({
  packageId,
  applyDomain,
  leadFormType,
}: {
  packageId?: string;
  applyDomain?: string;
  leadFormType?: "TY" | "LP";
}) {
  if (process.env.CONTENTFUL_PREVIEW !== "true" && leadFormType === "LP" && !packageId) {
    throw new Error("LeadFormIntegrated: Missing form ID for PLP form");
  }

  if (process.env.CONTENTFUL_PREVIEW !== "true" && leadFormType === "TY" && !applyDomain) {
    throw new Error("LeadFormIntegrated: Missing applyDomain for Thank You form");
  }
}

export function buildFormId(salt: string, packageId: string, applyDomain: string) {
  const slug = packageId || applyDomain.replace(/https?:\/\//, "").replace(/[.]/g, "-");
  return `${salt}-twou-form-${slug}`;
}
